import {
  Required,
  IsString,
  DataValidator,
  transformKeys,
} from "@/utils/type-vaildator";
import api from "./api";

// 原始接口
export interface AgentUserResponse {
  message: string;
  id: string;
  username: string;
  user_global_id: string;
  gender: string;
  email: string;
  company: string;
  personal_title: string;
  created_at: string;
};

// 请求接口
interface AgentUsersCreateRequest {
  agentId: string;
  username: string;
  gender: string;
  email: string;
  company: string;
  personalTitle: string;
}


export class AgentUserCreateData {
  @Required("Id cannot be empty")
  @IsString("Id must be a string")
  id: string;

  @Required("Username cannot be empty")
  @IsString("Username must be a string")
  username: string;

  @Required("Gender cannot be empty")
  @IsString("Gender must be a string")
  gender: string;

  @Required("Email cannot be empty")
  @IsString("Email must be a string")
  email: string;

  @Required("company cannot be empty")
  @IsString("company must be a string")
  company: string;

  @Required("Personal title cannot be empty")
  @IsString("Personal title must be a string")
  personalTitle: string;

  @Required("createdAt cannot be empty")
  @IsString("createdAt must be a string")
  createdAt: string;
}

const transformAndValidateAgent = (
  response: AgentUserResponse
): AgentUserCreateData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, AgentUserCreateData);
  } catch (error) {
    console.error("Agent User data validation failed:", error.message);
    throw error;
  }
};

/** 创建 Agent 用户 */
export const agentUserCreate = async ({ agentId, username, gender, email, company, personalTitle }: AgentUsersCreateRequest): Promise<AgentUserCreateData> => {
  const response = await api.post<AgentUserResponse>('/agent/user/create', {
    agent_id: agentId,
    username: username,
    gender: gender,
    email: email,
    company: company,
    personal_title: personalTitle,
  });
  const data = transformAndValidateAgent(response.data);
  return data;
};
